
let defs;

try { defs = __sappEsbuildDefs; } catch {}

export default defs;
export { defs };